(function(){
    /* Model */
    var Model = Backbone.Model.extend({
         urlRoot: APP_CONFIG.MEDIA_API_ROOT+"/assets/"
        ,parse:function(resp){
            return resp.results;    
        }
    })
    

/* 
    API

    Use: Backbone.Radio.channel('entities').request('shows')
    
    These return a promise, so you'll want to wrap them in a $.when or something. 
    e.g. 
    $.when( Backbone.Radio.channel('entities').request('shows') )
        .done(function(data){ 
            console.log('d',data) 
        })
*/ 
    var api = Backbone.Radio.channel('entities');

    //get a single item
    /* 
        ID can be a slug or an id. The api handles both 
    */
    api.reply('asset',function(id){
        var defer = $.Deferred()
            ,item = new Model({'id':id}) 
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })

})();